import { render, staticRenderFns } from "./Yasu2.vue?vue&type=template&id=255d49f5&scoped=true"
import script from "./Yasu2.vue?vue&type=script&lang=js"
export * from "./Yasu2.vue?vue&type=script&lang=js"
import style0 from "./Yasu2.vue?vue&type=style&index=0&id=255d49f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255d49f5",
  null
  
)

export default component.exports